var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ecircular-preview" }, [
    _c("div", {
      staticClass: "ecircular-preview__header",
      domProps: { innerHTML: _vm._s(_vm.dataSrc.header) },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "ecircular-preview__call-center" }, [
      _c("img", { attrs: { src: _vm.callCenterLogo } }),
    ]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _c("div", {
      staticClass: "ecircular-preview__description",
      domProps: { innerHTML: _vm._s(_vm.dataSrc.description) },
    }),
    _vm._v(" "),
    _c("div", {
      staticClass: "ecircular-preview__footer",
      domProps: { innerHTML: _vm._s(_vm.dataSrc.footer) },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "ecircular-preview__logo" }, [
      _c("img", {
        directives: [
          {
            name: "region-img-src",
            rawName: "v-region-img-src",
            value: "email-logo-hkland.png",
            expression: "'email-logo-hkland.png'",
          },
        ],
        attrs: { alt: _vm.$t("system.title") },
      }),
    ]),
    _vm._v(" "),
    _c("div", {
      key: new Date().getTime(),
      domProps: { innerHTML: _vm._s(_vm.dataSrc.signature) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }